import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { FormsMultilineInput, InlineFormInput } from '@platform/components';
import { PartnerIdByParamResponse } from '@platform/client/schemas';

export type PartnerFormData = {
  name: string;
  logo: string;
  description: string;
  link: string;
  active: boolean;
  urlParam?: string | null;
  linkedinUrl?: string | null;
};

type CreateFormProps = {
  control: Control<PartnerFormData>;
  register: UseFormRegister<PartnerFormData>;
  formState: FormState<PartnerFormData>;
  getValues: UseFormGetValues<PartnerFormData>;
  setValue: UseFormSetValue<PartnerFormData>;
  watch: UseFormWatch<PartnerFormData>;
};

export const checkPartnerUrlParamUnique = async (
  urlParam: string,
  formPartnerId: number | null,
) => {
  const urlExistsEndpoint =
    import.meta.env.VITE_API_HOST + '/admin/partners/partner_id-by-url-param';
  const response = await fetch(urlExistsEndpoint + `?url_param=${encodeURIComponent(urlParam)}`, {
    credentials: 'include',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (response.status === 200) {
    const responseData = (await response.json()) as PartnerIdByParamResponse;
    return !responseData.partnerId || responseData.partnerId === formPartnerId;
  } else {
    return false;
  }
};

export const PartnerForm = (props: CreateFormProps) => {
  const { control, register, formState, getValues, setValue, watch } = props;
  // format whatever input for urlParm to kebab-case
  const formatUrlOnBlur = () => {
    const existingUrlParam = getValues('urlParam');
    if (existingUrlParam) {
      setValue('urlParam', existingUrlParam.trim().toLowerCase().replaceAll(' ', '-'));
    }
  };
  return (
    // DG TO FIX THIS - form nested in form
    <form className='flex flex-col gap-4 md:min-w-[800px]' onBlur={() => formatUrlOnBlur()}>
      <InlineFormInput
        register={() => register('name', { required: 'Name required' })}
        label='Partner name'
        errors={formState.errors.name}
        customWidth='w-full'
      />

      <InlineFormInput
        register={() => register('urlParam', { onBlur: () => formatUrlOnBlur() })}
        label='Url parameter'
        errors={formState.errors.urlParam}
        customWidth='w-full'
      />
      <InlineFormInput
        prefixContent='https://'
        register={() => register('link', { required: 'Link required' })}
        label='Link'
        errors={formState.errors.link}
        customWidth='w-full'
      />
      <InlineFormInput
        prefixContent='https://'
        register={() => register('logo')}
        label='Logo URL'
        errors={formState.errors.logo}
        customWidth='w-full'
      />
      <InlineFormInput
        prefixContent='https://'
        register={() => register('linkedinUrl')}
        label='LinkedIn URL'
        errors={formState.errors.linkedinUrl}
        customWidth='w-full'
      />
      <FormsMultilineInput
        control={control}
        name='description'
        label='Description'
        placeholder='Enter partner description'
        rules={{ required: 'Description is required' }}
        formsError={formState.errors.description}
      />
      <div className='flex flex-row gap-2 h-15 items-center'>
        <input type='checkbox' {...register('active')} className='h-5 w-5 p-2 rounded-md' />
        <label htmlFor='is active'>{`${watch('active') === true ? 'Active - Users will be able to select this partner' : 'Inactive - Users will not be able to select this partner'}`}</label>
      </div>
    </form>
  );
};
